import {HeightAnimation} from '../animations/HeightAnimation';

export class Select {

    private hideCurrent:boolean=false;
    private hideNone:boolean=false;
    public static instances:Select[]=[];

    constructor (public selectContainer:JQuery<HTMLElement>) {
        for (let inst of Select.instances) {
            if (inst.selectContainer.is(selectContainer)) return inst;
        }
        this.clean();
        this.selectContainer=selectContainer;
        this.hideCurrent=<boolean>this.css('hide-current','false','bool');
        this.hideNone=<boolean>this.css('hide-none','false','bool');

        //Register event handler for optional toggle element
        let toggleElement=<string>this.css('toggle-element','','string');
        if (toggleElement) {
            selectContainer.closest(toggleElement).on("mousedown",(ev)=>this.toggleElementEvent(ev));
        }

        selectContainer.find('.select-button.form-text-info').on("click",(ev)=>this.infoEvent(ev));

        //Use mousedown with preventDefault to avoid that the focus is moved away
        selectContainer.find(".select-label").on("mousedown",(ev)=>this.toggleEvent(ev));
        selectContainer.find(".select-dropdown").on("mousedown",(ev)=>this.dropdownMouseDownEvent(ev));
        selectContainer.find("select").on("change",(ev,extraParameters)=>this.changeEvent(ev,extraParameters));
        selectContainer.on("keydown",(ev)=>this.keyEvent(ev));
        selectContainer.on("blur",(ev)=>this.blurEvent(ev));
        selectContainer.find(".select-button-clear").on("mousedown",(ev)=>{ev.stopPropagation();this.clear();this.close();});
        selectContainer.find(".select-button-toggle").on("mousedown",(ev)=>{ev.stopPropagation();this.toggle();this.close();});
        if (this.hideNone) selectContainer.find(".select-option-none").css('display','none');
        this.addAriaIDs();
        this.syncWidget();
        Select.instances.push(this);
    }

    private css(prop:string,def:string,type:string='string') {
        let r=this.selectContainer.css('--select-'+prop);
        if (typeof r=='string') r=r.trim();
        if (r===undefined) r=def;
        if (type=='bool') {
            if (r=='false') return false;
            if (r=='true') return true;
            throw 'Invalid boolean property value for property "'+prop+'"';
        }
        return r;
    }

    private addAriaIDs() {
        let id='aria-'+this.getUUID();
        this.selectContainer.attr('aria-controls',id);
        this.selectContainer.find(".select-dropdown").attr('id',id);
    }

    private getUUID() {
        return Math.random().toString(36).slice(2);
    }

    private changeEvent(ev:JQuery.TriggeredEvent,extraParameters:any) {
        if ((typeof extraParameters=='object') && extraParameters.internal) return;
        this.syncWidget();
    }

    private blurEvent(ev:JQuery.TriggeredEvent) {
       this.close();
    }

    private infoEvent(ev:JQuery.TriggeredEvent) {
        ev.preventDefault();
        ev.stopPropagation();
        this.selectContainer.find(".aria").toggleClass('visible');
    }

    private getVisibleOptions() {
        let dropDown=this.selectContainer.find(".select-dropdown");
        let options=dropDown.find('.select-option:not(.visually-hidden)');
        if (this.hideNone) options=options.not('.select-option-none');
        return options;
    }

    private async keyEvent(ev:JQuery.TriggeredEvent) {
        // Enter/Space key
        if (ev.key == 'Enter' || ev.key == ' ') {
            ev.preventDefault();
            ev.stopPropagation();

            let form = this.selectContainer.closest('form');
            if (!form.length || form.hasClass('searching')) return;

            if (!this.selectContainer.hasClass('open')) {
                this.open();
                return;
            }

            let dropDown=this.selectContainer.find(".select-dropdown");
            let focusedOption = dropDown.find('.select-option.focused');

            // If no option is focused when trying to select, focus the first visible option
            if (!focusedOption.length) {
                focusedOption = this.getVisibleOptions().first();
                focusedOption.addClass('focused');
            }

            var val=focusedOption.attr("data-value");
            if (val===undefined) return;

            if (this.isMultiple()) {
                this.toggleValue(val);
            } else {
                this.selectValue(val);
                focusedOption.removeClass('focused');
            }
        }

        // Esc key
        if (ev.key == 'Escape') {
            ev.preventDefault();
            this.close();
            return;
        }

        // Arrow up/down keys
        if (ev.key == 'ArrowUp' || ev.key == 'ArrowDown' || ev.key == 'Home' || ev.key == 'End' || ev.key?.match(/^[a-z]$/i)) {
            ev.preventDefault();

            let dropDown=this.selectContainer.find(".select-dropdown");
            let options=this.getVisibleOptions();

            if (!this.selectContainer.hasClass('open')) {
                options.filter('.selected').addClass('focused');
                await this.open();
            }

            let focusedOption = options.filter('.focused');
            let focusedIndex = options.index(focusedOption);
            let firstOption=options.first();
            let lastOption=options.last();
            let nextFocusedOption;

            if (ev.key == 'ArrowUp' || ev.key == 'ArrowDown') {
                if (focusedOption.length) {
                    let step=(ev.key=='ArrowUp')?-1:1;
                    focusedIndex+=step;
                    nextFocusedOption=options.eq(focusedIndex);
                }
                if (!nextFocusedOption || !nextFocusedOption.length) {
                    nextFocusedOption=(ev.key=='ArrowUp')?lastOption:firstOption;
                }
            } else if (ev.key == 'Home' || ev.key == 'End') {
                nextFocusedOption=(ev.key=='End')?lastOption:firstOption;
            } else {
                let char=ev.key.toLowerCase();
                let wrap=false;
                let originalFocusedIndex=focusedIndex;
                while (true) {
                    focusedIndex++;
                    if (focusedIndex==originalFocusedIndex && wrap) {
                        return;
                    }
                    if (focusedIndex>=options.length) {
                        if (originalFocusedIndex<0) return;
                        focusedIndex=-1;
                        wrap=true;
                        continue;
                    }
                    let myOption=options.eq(focusedIndex);
                    let nextText=myOption.length?myOption.text().trim().toLowerCase():'';
                    if (nextText.indexOf(char)===0) {
                        nextFocusedOption=myOption;
                        break;
                    }
                }
            }

            focusedOption.removeClass('focused');
            nextFocusedOption.addClass('focused');

            let id=nextFocusedOption.attr('id');
            if (!id) {
                id='aria-'+this.getUUID();
                nextFocusedOption.attr('id',id);
            }
            this.selectContainer.attr('aria-activedescendant',id);

            if (!this.checkInView(dropDown,nextFocusedOption,false)) {
                this.scrollIntoView(dropDown,nextFocusedOption);
            }

        }

    }

    private scrollIntoView(container:JQuery<HTMLElement>,elem:JQuery<HTMLElement>) {
        let shift=((container.height()??0)-(elem.height()??0))/2;
        let y=(elem.offset()?.top??0)+(container.scrollTop()??0)-(container.offset()?.top??0);
        container[0].scrollTo({top:y-shift,behavior:'smooth'});
    }

    private checkInView(container:JQuery<HTMLElement>,elem:JQuery<HTMLElement>,partial:boolean) {
        var contHeight = container.height()??0;
        var contTop = container.scrollTop()??0;
        var contBottom = contTop + contHeight ;

        var elemTop = ($(elem).offset()?.top??0) - (container.offset()?.top??0);
        var elemBottom = elemTop + ($(elem).height()??0);

        var isTotal = (elemTop >= 0 && elemBottom <=contHeight);
        var isPart = ((elemTop < 0 && elemBottom > 0 ) || (elemTop > 0 && elemTop <= (container.height()??0))) && partial ;

        return  isTotal || isPart ;
    }

    public toggle() {
        if (!this.selectContainer.hasClass('open')) {
            this.selectContainer.focus();
            this.open();
        } else {
            this.close();
        }
    }

    private toggleElementEvent(ev:JQuery.TriggeredEvent) {
        if ($(ev.target).closest(".select").length) return true;
        ev.preventDefault();
        this.toggle();
    }

    private toggleEvent(ev:JQuery.TriggeredEvent) {
        if ($(ev.target).closest(".select-dropdown").length) return true;
        ev.preventDefault();
        this.toggle();
    }

    public isMultiple() {
        var select=this.selectContainer.find("select");
        return select.is("[multiple]");
    }

    public hasAutoSubmit() {
        var form=this.selectContainer.closest("form");
        if (!form.length) return false;
        if (form.data("autosubmit")=="off") return false;
        if (form.hasClass("stepform")) return false;
        var select=this.selectContainer.find("select");
        return select.data("autosubmit")!="off";
    }

    private syncWidget() {
        var select=this.selectContainer.find("select");
        var is_multiple=this.isMultiple();
        var options=select.find("option");
        var widgetOptions=this.selectContainer.find(".select-option");
        var label=this.selectContainer.find(".select-label");
        var label_inner=this.selectContainer.find(".select-label-inner");
        if (label_inner.length) label=label_inner;
        var empty_option=select.find("option[value=''],option[value='_none'],option[value='All']");

        options.each(
            (idx,opt)=>{
                var val=$(opt).attr("value");
                var e=widgetOptions.filter((idx,x)=>{
                    return String($(x).data("value"))===String(val);
                });
                var is_selected=$(opt).is(":selected");
                e.toggleClass("selected",is_selected);
                if (this.hideCurrent && val !== empty_option.val()) {
                    e.closest('.select-option').toggleClass("visually-hidden",is_selected);
                }
                if (is_selected && !is_multiple) {
                    label.html(e.html());
                    label.find('.select-checkbox').remove();
                    this.selectContainer.toggleClass('select-none',val === empty_option.val());
                }
            }
        );

        if (is_multiple) {
            var the_label=(empty_option.length)?empty_option:this.selectContainer.closest('.js-form-type-select').find(".label");
            let selected=options.filter(':selected');
            this.selectContainer.toggleClass('select-none',selected.length==0);
            if (selected.length==0) {
                label.html(the_label.html());
            } else if (selected.length==1) {
                label.html(selected.first().html());
            } else {
                var multiple_option=this.selectContainer.data('multipleOption');
                label.html((multiple_option??the_label.html())+' ('+selected.length+')');
            }
        }

        this.selectContainer.attr("data-value",<string>select.val());
    }

    private isVisible() {
        let selectBox=this.selectContainer.find('.select-box');
        let dropDown=this.selectContainer.find('.select-dropdown');
        let r=selectBox[0].getBoundingClientRect();
        let oldPointerEvents=dropDown[0].style.pointerEvents;
        dropDown[0].style.pointerEvents='none';
        let e1=document.elementFromPoint(r.left,r.top)?.closest('.select-box,.select-button');
        let e2=document.elementFromPoint(r.right-1,r.top)?.closest('.select-box,.select-button')
        let e3=document.elementFromPoint(r.right-1,r.bottom-1)?.closest('.select-box,.select-button')
        let e4=document.elementFromPoint(r.left,r.bottom-1)?.closest('.select-box,.select-button')
        dropDown[0].style.pointerEvents=oldPointerEvents;
        return e1 && e2 && e3 && e4;
    }

    private handleAutoClose(dropdown:JQuery) {
        let interval=setInterval(
            ()=>{
                if (!this.selectContainer.hasClass('open') &&
                    !this.selectContainer.hasClass('opening')) {
                    clearInterval(interval);
                    return;
                }
                if (!this.isVisible()) {
                    clearInterval(interval);
                    this.close();
                    return;
                }
            },
            1
        );
    }

    public async open() {
        if (this.selectContainer.hasClass('open')) return;
        if (this.selectContainer.hasClass('opening')) return;
        this.selectContainer.attr("aria-expanded","true");
        let selectDropdown = this.selectContainer.find(".select-dropdown");
        this.selectContainer.addClass("opening");
        this.handleAutoClose(selectDropdown);
        let animation = new HeightAnimation(selectDropdown);
        await animation.to('auto').play();
        this.selectContainer.removeClass('opening');
        this.selectContainer.addClass("open");
    }

    public async close() {
        if (!this.selectContainer.hasClass('open')) return;
        this.selectContainer.attr("aria-expanded","false");
        let selectDropdown = this.selectContainer.find('.select-dropdown');
        this.selectContainer.removeClass("open");
        this.selectContainer.addClass("closing");
        let animation = new HeightAnimation(selectDropdown);
        await animation.to(0).play();
        this.selectContainer.removeClass("closing");
    }

    public submit() {
        var form=this.selectContainer.closest("form");
        if (!form.find("[type=submit]:visible").length && this.hasAutoSubmit()) {
            var btn=form.find("[type=submit]");
            if (btn.length) btn.click(); else form.submit();
            //data-dom-id is added when DrupalX renders a view's detached exposed form.
            //In this case we can not expect that a submit replaces the whole form.
            //We need to close the select box ourselves. For custom forms, we need
            // the flag is-ajax which is e.g. set by AjaxSearch
            if ((form.data('dom-id') || form.hasClass('is-ajax')) && !this.isMultiple()) this.close();
        } else {
            this.close();
        }
        var select=this.selectContainer.find("select");
        select.trigger("change",{internal:true});
    }

    public clear() {
        var select=this.selectContainer.find("select");
        var options=select.find("option:selected");
        options.prop("selected",false);
        this.syncWidget();
        if (!this.isMultiple()) select.prop('selectedIndex',null);
        select.trigger("change",{internal:true});
        this.submit();
    }

    public toggleValue(val:string) {
        var select=this.selectContainer.find("select");
        var options=select.find("option");
        var opt=options.filter(function(idx,x) {return String($(x).attr("value"))===String(val);});
        opt.prop("selected",!opt.is(":selected"));
        this.syncWidget();
        this.submit();
    }

    public selectValue(val:string) {
        var select=this.selectContainer.find("select");
        var options=select.find("option");
        var opt=options.filter(function(idx,x) {return String($(x).attr("value"))===String(val);});
        if (!this.isMultiple()) options.not(opt).prop("selected",false);
        opt.prop("selected",true);
        this.syncWidget();
        this.submit();
    }

    public unselectValue(val:string) {
        var select=this.selectContainer.find("select");
        var options=select.find("option");
        var opt=options.filter(function(idx,x) {return String($(x).attr("value"))===String(val);});
        opt.prop("selected",false);
        this.syncWidget();
        this.submit();
    }

    private dropdownMouseDownEvent(ev:JQuery.TriggeredEvent) {
        ev.preventDefault();
        var option=$(ev.target).closest('.select-option');
        if (!option.length) return;
        var val=option.attr("data-value");
        if (val===undefined) return;
        if (this.isMultiple()) {
            this.toggleValue(val);
        } else {
            this.selectValue(val);
        }
    }

    private clean() {
        let existingInstances:Select[]=[];
        for (let inst of Select.instances) {
            if ($('body').has(inst.selectContainer[0]).length) existingInstances.push(inst);
        }
        Select.instances=existingInstances;
    }

    static {
        $().ready(()=>{
                $('body').on('click',(ev)=>{
                    for (var inst of Select.instances) {
                        if (!inst.selectContainer.has(ev.target).length) {
                            inst.close();
                        }
                    }
                });
            }
        );
    }

}

export {};